import { Page, PageHeader } from "@/ui";
import { ApprovalsInbox } from "@/components/ApprovalsInbox";

/** Org admin's inbox — the final step in `counter_then_sales_rep`, and the fallback when a counter has no sales rep (D-07). */
export function ApprovalsPage() {
  return (
    <Page bleed>
      <PageHeader title="Approvals" />
      <ApprovalsInbox />
    </Page>
  );
}
